/**
 * Get the base URL for the application based on the environment
 * In development, uses the DEV_URL from environment variables
 * In production, uses the SITE_URL from environment variables
 * Falls back to localhost if neither is set
 */
export function getBaseUrl(): string {
  // In production, use the production URL
  if (process.env.NODE_ENV === 'production') {
    return process.env.NEXT_PUBLIC_SITE_URL || 'https://behes.dev';
  }
  
  // In development, use the development URL
  return process.env.NEXT_PUBLIC_DEV_URL || 'http://localhost:3000';
}

/**
 * Get the absolute URL for a given path
 * @param path - The path to append to the base URL
 */
export function getAbsoluteUrl(path: string): string {
  const baseUrl = getBaseUrl();
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}